import { useUserStore } from '../stores/userStore';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('app:beforeMount', async () => {
        const { fetchUserPool } = useUserStore();
        await fetchUserPool();
    });
});
